import { render, staticRenderFns } from "./CrmAgencyDetails.vue?vue&type=template&id=5f09fe1d"
import script from "./CrmAgencyDetails.vue?vue&type=script&lang=js"
export * from "./CrmAgencyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports